import _styled from '@emotion/styled-base';
import React__default from 'react';
import { Tag } from '@blueprintjs/core';
import { Text } from '../text/text.js';
import { ConditionBuilderCombinator } from './condition-builder-combinator.js';
import { DropdownMenu } from '../dropdown-menu/dropdown-menu.js';
import { Button } from '../button/button.js';
import { ChevronDown32 } from '@carbon/icons-react';

var ConditionBuilderHeaderWrapper = /*#__PURE__*/_styled("div", {
  target: "e1kldxf80"
})({
  name: "11jm6i5",
  styles: "display:flex;flex-direction:row;align-items:flex-start;gap:0.5rem;"
});

var ConditionBuilderCombinatorSelectorTag = /*#__PURE__*/_styled(Tag, {
  target: "e1kldxf81"
})("width:3.5rem;margin:", function (_ref) {
  var combinatorEditable = _ref.combinatorEditable,
      readOnly = _ref.readOnly;
  return combinatorEditable && !readOnly && "0.25rem 0";
}, ";text-align:center;");

var ConditionBuilderStatement = /*#__PURE__*/_styled("div", {
  target: "e1kldxf82"
})("display:flex;flex-direction:column;justify-content:center;min-height:", function (_ref2) {
  var combinatorEditable = _ref2.combinatorEditable,
      readOnly = _ref2.readOnly;
  return !combinatorEditable || readOnly ? "1.5rem" : "2rem";
}, ";font-weight:600;font-size:", function (_ref3) {
  var vertical = _ref3.vertical;
  return vertical && "0.75rem";
}, ";line-height:1;");

var ConditionBuilderHeader = function ConditionBuilderHeader(_ref4) {
  var andCombinatorTagText = _ref4.andCombinatorTagText,
      combinator = _ref4.combinator,
      _ref4$combinatorEdita = _ref4.combinatorEditable,
      combinatorEditable = _ref4$combinatorEdita === void 0 ? true : _ref4$combinatorEdita,
      dispatch = _ref4.dispatch,
      groupId = _ref4.groupId,
      ifAllCombinatorDescriptionText = _ref4.ifAllCombinatorDescriptionText,
      ifAllCombinatorSelectionText = _ref4.ifAllCombinatorSelectionText,
      ifAnyCombinatorDescriptionText = _ref4.ifAnyCombinatorDescriptionText,
      ifAnyCombinatorSelectionText = _ref4.ifAnyCombinatorSelectionText,
      orCombinatorTagText = _ref4.orCombinatorTagText,
      readOnly = _ref4.readOnly,
      selectedCombinator = _ref4.selectedCombinator,
      vertical = _ref4.vertical;
  return /*#__PURE__*/React__default.createElement(ConditionBuilderHeaderWrapper, {
    className: "vds-condition-builder-header"
  }, /*#__PURE__*/React__default.createElement(ConditionBuilderCombinator, {
    andCombinatorTagText: andCombinatorTagText,
    combinator: combinator,
    combinatorEditable: combinatorEditable,
    orCombinatorTagText: orCombinatorTagText,
    readOnly: readOnly,
    vertical: vertical
  }), readOnly || !combinatorEditable ? /*#__PURE__*/React__default.createElement(ConditionBuilderCombinatorSelectorTag, {
    className: "vds-condition-builder-combinator-selector-tag ".concat(selectedCombinator === "all" ? "vds-highlight-06" : "vds-highlight-05"),
    combinatorEditable: combinatorEditable,
    readOnly: readOnly,
    vertical: vertical
  }, /*#__PURE__*/React__default.createElement(Text, {
    ellipsize: true
  }, selectedCombinator === "all" ? ifAllCombinatorSelectionText : ifAnyCombinatorSelectionText)) :
  /*#__PURE__*/

  /**
   * DropdownMenu inserts a DOM node below itself when open.
   * Extra wrapping div is required to prevent the insertion
   * of an extra flex gap.
   */
  React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(DropdownMenu.Menu, {
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownMenu.Item, {
      onSelect: function onSelect() {
        return dispatch({
          type: "UPDATE_GROUP_COMBINATOR",
          payload: {
            groupId: groupId,
            groupCombinator: "all"
          }
        });
      },
      text: ifAllCombinatorSelectionText
    }), /*#__PURE__*/React__default.createElement(DropdownMenu.Item, {
      onSelect: function onSelect() {
        return dispatch({
          type: "UPDATE_GROUP_COMBINATOR",
          payload: {
            groupId: groupId,
            groupCombinator: "any"
          }
        });
      },
      text: ifAnyCombinatorSelectionText
    })),
    placement: "bottom-start",
    target: /*#__PURE__*/React__default.createElement(Button, {
      text: /*#__PURE__*/React__default.createElement(Text, {
        ellipsize: true
      }, selectedCombinator === "all" ? ifAllCombinatorSelectionText : ifAnyCombinatorSelectionText),
      rightIcon: ChevronDown32,
      type: "button"
    })
  })), /*#__PURE__*/React__default.createElement(ConditionBuilderStatement, {
    className: "vds-condition-builder-statement",
    combinatorEditable: combinatorEditable,
    readOnly: readOnly,
    vertical: vertical
  }, selectedCombinator === "all" ? ifAllCombinatorDescriptionText : ifAnyCombinatorDescriptionText));
};

export { ConditionBuilderHeader };
//# sourceMappingURL=condition-builder-header.js.map
